import React from 'react';
import PropTypes from 'prop-types';
import SelectionsIconButton from './SelectionsIconButton';
import SelectionsItemText from './SelectionsItemText';
import { ListItem, ListItemSecondaryAction } from '@material-ui/core';
import * as Icon from '@material-ui/icons';

const SelectionsListItem = ({
    isNested,
    hasDropdown,
    clearSelections,
    handleDropDown,
    value,
    open,
    classes,
}) => (
    <ListItem button className={isNested ? classes.nested : ''}>
        <SelectionsIconButton handleClearSelections={clearSelections} />
        <SelectionsItemText value={value} />
        {hasDropdown && (
            <ListItemSecondaryAction onClick={handleDropDown}>
                {open === value.field ? (
                    <Icon.ExpandLess style={{ color: '#878c91' }} />
                ) : (
                    <Icon.ExpandMore style={{ color: '#878c91' }} />
                )}
            </ListItemSecondaryAction>
        )}
    </ListItem>
);

SelectionsListItem.propTypes = {
    value: PropTypes.string.isRequired,
    clearSelections: PropTypes.func.isRequired,
    isNested: PropTypes.bool,
    hasDropdown: PropTypes.bool,
    handleDropDown: PropTypes.func,
    open: PropTypes.any,
    classes: PropTypes.object,
};

SelectionsListItem.defaultProps = {
    isNested: false,
    hasDropdown: false,
};

export default SelectionsListItem;
